import { DoodOrderStatus } from './order.model';

export const DOOD_ORDER_HISTORICAL_STATUS = [DoodOrderStatus.collected];
